import { request } from '@/common/services/request';

const toProTableResult = (result) => ({
  data: result.data || [],
  success: true,
  total: result.meta?.total || 0,
});

const getSortQuery = (params) => {
  if (params.sortField) {
    return {
      order: params.order,
      sortField: params.sortField,
    };
  }
  const entries = Object.entries(params.sort || {}).filter(([, value]) => value);
  if (!entries.length) {
    return {};
  }
  const [sortField, order] = entries[0];
  return { order, sortField };
};

const getQueryParams = (params = {}) =>
  Object.fromEntries(
    Object.entries({
      accountId: params.accountId,
      accountKey: params.accountKey,
      accountType: params.accountType,
      current: params.current,
      end: params.end,
      latestOnly: params.latestOnly,
      name: params.name,
      organizationId: params.organizationId,
      pageSize: params.pageSize,
      platform: params.platform,
      start: params.start,
      title: params.title,
      ...getSortQuery(params),
    }).filter(([, value]) => value !== undefined && value !== ''),
  );

export async function queryTraceContentLogs(params) {
  const result = await request('/api/trace/tenant/content-logs', {
    method: 'GET',
    params: getQueryParams(params),
  });
  return toProTableResult(result);
}

const queryTraceContentLogAccountPage = async (params, current, accounts) => {
  const result = await request('/api/trace/tenant/accounts', {
    method: 'GET',
    params: {
      accountType: params.accountType,
      current,
      organizationId: params.organizationId,
      pageSize: 100,
    },
  });
  const pageAccounts = result.data || [];
  const allAccounts = [...accounts, ...pageAccounts];
  return pageAccounts.length === 0 || allAccounts.length >= Number(result.meta?.total || 0)
    ? allAccounts
    : queryTraceContentLogAccountPage(params, current + 1, allAccounts);
};

export const queryTraceContentLogAccounts = (params = {}) =>
  queryTraceContentLogAccountPage(params, 1, []);

export async function refreshTraceContentLogVideo(params = {}) {
  return request('/api/trace/tenant/content-logs/video', {
    method: 'PATCH',
    params: {
      id: params.id,
      organizationId: params.organizationId,
    },
  });
}
